/**
 * @generated SignedSource<<8823db13a74e880d320df76ae082abde>>
 * @relayHash b53e9692429e50c771f93c104ac14900
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b53e9692429e50c771f93c104ac14900

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SteeringLevelValue = "FOUR" | "MINUS_ONE" | "ONE" | "THREE" | "TWO" | "ZERO";
export type WaitingTimeStatus = "CALCULATED" | "EXCEEDS_MAXIMUM";
export type useSteeringLevelsCapacityQuery$variables = Record<PropertyKey, never>;
export type useSteeringLevelsCapacityQuery$data = {
  readonly steeringLevels: ReadonlyArray<{
    readonly id: string;
    readonly isAutomatic: boolean;
    readonly language: Language;
    readonly level: SteeringLevelValue;
    readonly levelValue: number;
    readonly waitingTime: {
      readonly minutesToWait: number;
      readonly status: WaitingTimeStatus;
    };
  }>;
};
export type useSteeringLevelsCapacityQuery = {
  response: useSteeringLevelsCapacityQuery$data;
  variables: useSteeringLevelsCapacityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SteeringLevel",
    "kind": "LinkedField",
    "name": "steeringLevels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "level",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "levelValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAutomatic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WaitingTime",
        "kind": "LinkedField",
        "name": "waitingTime",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutesToWait",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSteeringLevelsCapacityQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSteeringLevelsCapacityQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "b53e9692429e50c771f93c104ac14900",
    "metadata": {},
    "name": "useSteeringLevelsCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f21999ea77ee82bc04e430358eb56642";

export default node;
